import { mapArray } from '../../functional-helpers.js';
import { lowerMessage, liftMessage } from '../../stdlib/msg/bindings-assemblyscript.js';

const createIoMessageReceiversBindings = ({ metadata, refs, }) => Object.entries(metadata.settings.io.messageReceivers).reduce((bindings, [nodeId, spec]) => ({
    ...bindings,
    [nodeId]: {
        type: 'proxy',
        value: mapArray(spec, (inletId) => [
            inletId,
            (message) => {
                const messagePointer = lowerMessage(refs.rawModule, message);
                refs.rawModule.io.messageReceivers[nodeId][inletId](messagePointer);
            },
        ]),
    },
}), {});
const createIoMessageSendersBindings = ({ metadata, }) => Object.entries(metadata.settings.io.messageSenders).reduce((bindings, [nodeId, spec]) => ({
    ...bindings,
    [nodeId]: {
        type: 'proxy',
        value: mapArray(spec, (outletId) => [
            outletId,
            (_) => undefined,
        ]),
    },
}), {});
const ioMsgSendersImports = ({ metadata, refs, }) => {
    const wasmImports = {};
    const { variableNamesIndex } = metadata.compilation;
    Object.entries(metadata.settings.io.messageSenders).forEach(([nodeId, spec]) => {
        spec.forEach((outletId) => {
            const listenerName = variableNamesIndex.io.messageSenders[nodeId][outletId];
            wasmImports[listenerName] = (messagePointer) => {
                const message = liftMessage(refs.rawModule, messagePointer);
                refs.engine.io.messageSenders[nodeId][outletId](message);
            };
        });
    });
    return wasmImports;
};

export { createIoMessageReceiversBindings, createIoMessageSendersBindings, ioMsgSendersImports };
